module.exports = __webpack_public_path__ + "static/media/paper_types_modal.b5a6b497.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/invitations/paper_types_modal.jpg
// module id = 1540
// module chunks = 70